export default __webpack_public_path__ + "static/media/glass-furnace.8f2855cb.svg";